import React, { FunctionComponent } from 'react';

import callOutImgSrc from './assets/JG_Awards_Vote.png';
import styles from './CallOut.module.scss';
import config from '../../config';

export const CallOut: FunctionComponent = () => {
  return (
    <section className={styles.callOut}>
      <div className={`container ${styles.container}`}>
        <div className={`jg-space-mtsm ${styles.callOutWrapper}`}>
          <div className={`jg-display-ib ${styles.content}`}>
            <h2 className={`jg-display-ib jg-space-ptmd ${styles.header}`}>
              2025 JustGiving Awards - Voting Now Open
            </h2>
            <p className={`jg-display-ib ${styles.description} jg-space-mtsm`}>
              Vote for your favourite fundraising heroes in the 2025 JustGiving
              Awards. Read the stories of those who have gone above and beyond
              for a cause they care about.
              <br />
              <b>Votes close 31st August.</b>
            </p>

            <div className={`jg-space-mtsm ${styles.buttonWrapper}`}>
              <a
                className={`jg-btn--ghost jg-space-mbm ${styles.button}`}
                href={config.jgAwardsVoteUrl}
              >
                Vote now
              </a>
            </div>
          </div>

          <div className={`jg-display-ib ${styles.content} jg-flex-asc`}>
            <a href={config.jgAwardsVoteUrl} tabIndex={-1} aria-hidden>
              <img
                src={callOutImgSrc}
                alt="Vote now"
                className={`jg-space-psm callOut-img ${styles.callOutImg}`}
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
